import { Target, Zap, Globe2, BarChart3, ArrowUpRight } from "lucide-react";
import { useReveal } from "../lib/useReveal";

const points = [
  {
    icon: Target,
    title: "Native to internet culture",
    text: "Briefs land. Concepts cut through. Nothing feels forced.",
  },
  {
    icon: Zap,
    title: "Speed without chaos",
    text: "From outreach to live in days, not weeks.",
  },
  {
    icon: Globe2,
    title: "Cross-platform reach",
    text: "TikTok, Instagram, and music-adjacent audiences in one ecosystem.",
  },
  {
    icon: BarChart3,
    title: "Reporting you can ship",
    text: "Wrap reports your CMO will actually read.",
  },
];

export const ForBrands = () => {
  const headRef = useReveal();
  return (
    <section
      id="brands"
      data-testid="for-brands-section"
      className="relative bg-[#050505] py-24 md:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="rounded-3xl border border-white/10 bg-[#0a0a0a] p-8 md:p-14 lg:p-20 relative overflow-hidden">
          <div
            aria-hidden="true"
            className="pointer-events-none absolute -top-24 -left-24 h-72 w-72 rounded-full bg-white/[0.04] blur-3xl"
          />

          <div ref={headRef} className="reveal grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-12">
            <div className="lg:col-span-7">
              <span className="text-xs uppercase tracking-[0.28em] text-neutral-500 font-medium">
                06 / For Brands
              </span>
              <h2
                data-testid="for-brands-heading"
                className="mt-6 font-display text-4xl sm:text-5xl md:text-6xl font-light tracking-tighter leading-[1.02]"
              >
                Work with creators who
                <br />
                <span className="italic font-medium">actually move culture.</span>
              </h2>
            </div>
            <div className="lg:col-span-5 flex flex-col gap-6">
              <p className="text-base md:text-lg text-neutral-400 leading-relaxed">
                Partner with creators who understand internet culture and viral
                marketing — and the team that knows how to scale them into a campaign.
              </p>
              <a
                href="#contact"
                data-testid="for-brands-cta"
                className="inline-flex items-center gap-2 self-start bg-white text-black hover:bg-neutral-200 transition-colors rounded-full px-6 py-3 text-sm font-medium tracking-wide"
              >
                Start a campaign
                <ArrowUpRight className="h-4 w-4" />
              </a>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {points.map((p, i) => (
              <PointCard key={p.title} {...p} index={i} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

const PointCard = ({ icon: Icon, title, text, index }) => {
  const ref = useReveal();
  return (
    <div
      ref={ref}
      data-testid={`for-brands-point-${index}`}
      style={{ transitionDelay: `${index * 80}ms` }}
      className="reveal rounded-[20px] border border-white/10 bg-[#0d0d0d] hover:border-white/30 hover:-translate-y-1.5 transition-all duration-500 p-6 min-h-[200px] flex flex-col justify-between border-shine"
    >
      <div className="h-10 w-10 rounded-full border border-white/15 bg-white/5 flex items-center justify-center">
        <Icon className="h-4.5 w-4.5 text-white" strokeWidth={1.5} />
      </div>
      <div className="mt-7">
        <h3 className="font-display text-lg md:text-xl font-medium tracking-tight">
          {title}
        </h3>
        <p className="mt-2 text-sm text-neutral-400 leading-relaxed">{text}</p>
      </div>
    </div>
  );
};

export default ForBrands;
